import React, { useEffect, useState } from "react";

import { useForm } from "react-hook-form";

import { getAllGroupList } from "../../services/Group/GroupServices";
import GroupMasterModal from "./GroupMasterModal";

import SearchDropdown from "../../../../../common/components/FormFields/searchDropdown";
import CommonButton from "../../../../../common/components/Buttons/CommonButton";
import LoadingSpinner from "../../../../../common/components/loadingspinner/loadingSpinner";
import CommonBackDrop from "../../../../../common/components/CommonBackDrop/CommonBackDrop";
import CommonTransactionPaginationTable from "../../../../../common/components/CommonTable/CommonTransactionPaginationTable";
import { DeleteIcon, EditIcon } from "../../../../../assets/CommonAssets";
import { UseCheckConsecutiveCharacters } from "../../../../../common/components/Custom Hooks/UseCheckConsecutiveCharacters";
import ConfirmationModal from "../../../../../common/components/ConfirmationModal";
import CommonHeading from "../../../../../common/components/Custom Hooks/CommonHeading";

/****************** user actions configuration ******************/
const userActions = [
  {
    id: 0,
    permission: "Edit",
    isAction: true,
  },
  {
    id: 1,
    permission: "Delete",
    isAction: true,
  },
  {
    id: 2,
    permission: "Create",
    isAction: false,
  },
];

const GroupMaster = () => {
  const [GroupMasterModalOpen, setGroupMasterModalOpen] = useState(false);
  // const [GroupMasterData, setGroupMasterData] = useState(records);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);
  const [selectedRow, setSelectedRow] = useState(null);
  const [spinner, showSpinner] = React.useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [searchString, setSearchString] = useState(null);
  const [openBackDrop, setOpenBackdrop] = useState(false);
  const [GroupMasterList, setGroupMasterList] = useState();
  const [GroupMasterNameOptions, setGroupMasterNameOptions] = useState([]);
  const [count, setCount] = useState(0);
  const { control, watch } = useForm();
  /****************** form handling functions ******************/
  const populateTable = (forPagination) => {
    let tempObj = {
      searchString: searchString !== null ? searchString.label : "",
      page: !forPagination ? 0 : page,
      size: rowsPerPage,
      searchId: searchString !== null ? searchString.Id : null,
      menuId: null,
    };
    showSpinner(true);
    getAllGroupList(tempObj)
      .then((response) => response.data)
      .then((res) => {
        console.log("resssssssss", res);
        if (res.statusCode === 200 || res.statusCode === 204) {
          console.log("forPaginationforPagination", forPagination);
          if (forPagination) {
            setGroupMasterList((prevData) => [...prevData, ...res.result]);
          } else {
            setGroupMasterList(res.result);
          }
          setCount(res.count);
          showSpinner(false);
        }
      })
      .catch((error) => {
        console.log(error);
        showSpinner(false);
      });
  };

  //   const handleDelete = () => {
  //     setOpenBackdrop(true);

  //     if (selectedRow !== null) {
  //       deleteGroupMaster(selectedRow.Id)
  //         .then((response) => response.data)
  //         .then((res) => {
  //           console.log("aaaaaaaaaaa", res);
  //           successAlert(res.message);
  //           // setPage(0)
  //           populateTable();
  //           setOpenDeleteModal(false);
  //           setOpenBackdrop(false);
  //           setSelectedRow(null);
  //         })
  //         .catch((errors) => {
  //           console.log("err", errors);
  //           setOpenDeleteModal(false);
  //           setOpenBackdrop(false);
  //           setGroupMasterModalOpen(false);
  //           setSelectedRow(null);

  //         });
  //     }
  //   };
  useEffect(() => {
    populateTable();
  }, []);
  /****************** renderActions function ******************/
  const renderActions = (row, index) => {
    return (
      <div className="flex gap-0 items-center">
        {userActions.map((actions, i) => (
          <>
            {actions.isAction === true ? (
              <>
                <div className="flex gap-2 cursor-pointer ">
                  {actions.permission === "Edit" ? (
                    <button
                      type={"button"}
                      onClick={() => {
                        setGroupMasterModalOpen(true);
                        setSelectedRow(row);
                      }}
                    >
                      <EditIcon title={"Edit"} sx={{ color: "gray" }} />
                    </button>
                  ) : null}
                </div>
              </>
            ) : null}
            {actions.isAction === true ? (
              <>
                <div className="flex gap-2 cursor-pointer">
                  {actions.permission === "Edit" ? (
                    <button
                      type={"button"}
                      onClick={() => {
                        setOpenDeleteModal(true);
                        setSelectedRow(row);
                      }}
                    >
                      <DeleteIcon sx={{ color: "#D11A2A" }} />
                    </button>
                  ) : null}
                </div>
              </>
            ) : null}
          </>
        ))}
      </div>
    );
  };
  /****************** renderInput ********************/
  const renderInput = (row, index, header) => {
    return (
      <>
        {header === "Status" && (
          <button
            className={`h-6 w-24 whitespace-nowrap border rounded capitalize px-5 text-center
                     ${
                       row?.Status === true
                         ? "text-customGreen border-customGreen"
                         : "text-customRed border-customRed"
                     }`}
            type="button"
          >
            {row?.Status === true ? "Active" : "InActive"}
          </button>
        )}
      </>
    );
  };

  return (
    <div className="px-2 my-1">
      {CommonHeading("Group")}

      <div className="flex gap-2 w-full items-center mt-2">
        <div className="flex w-full gap-2 items-center">
          <div className="grid w-full grid-cols-2 gap-2">
            <div className="flex gap-2">
              <SearchDropdown
                control={control}
                name="group"
                placeholder="Search by Group*"
                isSearchable={true}
                dataArray={[]}
                searchIcon={true}
                handleInputChange={(e) => {
                  const tempCheckChar =
                    e !== null ? UseCheckConsecutiveCharacters(e) : true;
                  if (e !== "" && tempCheckChar) {
                  }
                }}
                onChange={(e) => {
                  setSearchString(e !== "" ? e : null);
                }}
                isClearable={true}
              />
              <CommonButton
                className="bg-customBlue text-white"
                searchIcon={true}
                onClick={() => populateTable()}
              />
            </div>
            {/* <div className="flex gap-2">
              <DatePickerField
                // error={errors.fromDate}
                slotProps={{ textField: { size: "small" } }}
                control={control}
                name="fromDate"
                label="From Date"
                maxDate={watch("toDate")}
                inputFormat="dd-MM-yyyy"
                // minDate={true}
              />
              <DatePickerField
                // error={errors.toDate}
                slotProps={{ textField: { size: "small" } }}
                name="toDate"
                label="To Date"
                inputFormat="dd-MM-yyyy"
                control={control}
                minDate={watch("fromDate")}
              />
            </div> */}
          </div>
        </div>
        <div className="grid justify-end xl:col-span-3 w-1/3">
          {userActions &&
            userActions.map((obj) => (
              <>
                {!obj.isAction && obj.permission === "Create" ? (
                  <CommonButton
                    onClick={() => setGroupMasterModalOpen(true)}
                    label="+ New"
                    className="modalButton bg-customBlue text-white"
                  />
                ) : null}
              </>
            ))}
        </div>
      </div>
      {spinner ? (
        <div className="grid justify-center items-center pt-12">
          <LoadingSpinner />
        </div>
      ) : null}

      {openBackDrop && <CommonBackDrop openBackdrop={openBackDrop} />}
      {GroupMasterModalOpen && (
        <GroupMasterModal
          setGroupMasterModalOpen={setGroupMasterModalOpen}
          GroupMasterModalOpen={GroupMasterModalOpen}
          // setGroupMasterData={setGroupMasterData}
          // GroupMasterData={GroupMasterData}
          selectedRow={selectedRow}
          setSelectedRow={setSelectedRow}
          populateTable={populateTable}
          openBackDrop={openBackDrop}
          setOpenBackdrop={setOpenBackdrop}
          setGroupMasterList={setGroupMasterList}
          GroupMasterList={GroupMasterList}
        />
      )}
      <div>
        {GroupMasterList?.length > 0 && !spinner ? (
          <CommonTransactionPaginationTable
            page={page}
            rowsPerPage={rowsPerPage}
            setPage={setPage}
            // populateTable={populateTable}
            count={GroupMasterList?.length}
            highlightRow={false}
            dataResult={GroupMasterList}
            renderActions={renderActions}
            renderInput={renderInput}
            editableColumns={"Status"}
            removeHeaders={[
              "id",
              "trainingId",
              "id",
              "employees",
              "trainingId",
              "Employee Details",
              "Unit Id",
              "Department Id",
              "Group Id",
            ]}
            tableClass="capitalize"
          />
        ) : (
          <>
            {!spinner && (
              <div className="flex justify-center">
                <h3 className="flex justify-center mt-20 font-bold text-gray-600">
                  No Records Found...
                </h3>
              </div>
            )}
          </>
        )}
      </div>

      {openDeleteModal && (
        <ConfirmationModal
          confirmationOpen={openDeleteModal}
          confirmationHandleClose={() => {
            setOpenDeleteModal(false);
            setSelectedRow(null);
          }}
          confirmationLabel="Confirmation"
          confirmationMsg="Are you sure you want to delete this record?"
          confirmationSubmitFunc={() => {}}
          confirmationButtonMsg="Delete"
        />
      )}
    </div>
  );
};

export default GroupMaster;
